import React, { useEffect, useState, useContext } from 'react'
import { CButton, CModal, CModalBody, CModalFooter } from '@coreui/react'
import '../cms/content.scss'
import 'simplebar/dist/simplebar.min.css'
import { convertDuration, formatBytes, isEmpty, raiseToast } from '../../utils/helper'
import moment from 'moment'
import { getThumbnail, getVideoThumbnail } from '../../utils/helper'
import { AppContext } from 'src/views/context/app'
import useAxios from 'axios-hooks'
import { ASSET_API } from '../../utils/urls'
import Loading from 'react-fullscreen-loading'
import InfiniteScroll from 'react-infinite-scroll-component'
import { GlobalContext } from 'src/views/context/GlobalState'
import { PAGE_SIZE } from 'src/views/utils/constants'
import GridViewIcon from '../../../assets/Content-Icons/Svgs/grid-view-icon.svg'
import ListViewIcon from '../../../assets/Content-Icons/Svgs/list-view-icon.svg'
import './AssetManagerCustom.css'
import CustomCard from './customCard'
import AssetFilter from './AssetFilter'
import PreviewDetails from './PreviewDetails'
import { capitalize } from 'lodash'
import CustomListCard from './customListCard'

const AssetManagerNew = ({ onCancel, type, setAsset }) => {
  const accountId = localStorage.getItem('accountId')
  const [assetData, setAssetData] = useState([])
  const { userSessionObj } = useContext(GlobalContext)

  const [searchText, setSearchText] = useState('')
  const [sizeFilter, setSizeFilter] = useState('')
  const [mappedFilter, setMappedFilter] = useState(null)
  const [dateFilter, setDateFilter] = useState('')
  const [dateCheckedValue, setDateCheckedValue] = useState('')
  const [orderByFilter, setOrderByFilter] = useState('created_at')
  const [reverse, setReverse] = useState(true)
  const [typeFilter, setTypeFilter] = useState([])

  const [selectedAsset, setSelectedAsset] = useState({})
  const [previewSlider, setPreviewSlider] = useState(false)

  const [listView, setListView] = useState(false) // state to set the grid view and list view

  const { setLoader, loader } = useContext(AppContext)
  const [page, setPage] = useState(1)
  const filterIntialValue = [
    {
      title: 'Upload Date',
      type: 'radio',
      checkedState: '',
      options: [
        { name: 'Today', value: 'day' },
        { name: 'This Week', value: 'week' },
        { name: 'This Month', value: 'month' },
        { name: 'This Year', value: 'year' },
      ],
      onSelect: (value) => {
        onDateFilterChange(value)
      },
    },
    {
      title: 'Size',
      type: 'radio',
      checkedState: '',
      options: [
        { name: 'Less than 500 MB', value: '0,524288000' },
        { name: 'Less than 1 GB', value: '0,1072693248' },
        { name: 'Less than 5 GB', value: '0,5367660544' },
        { name: 'More than 5 GB', value: '5473566720,-1' },
      ],
      onSelect: (value) => {
        onSizeFilterChange(value)
      },
    },
    {
      title: 'Type',
      type: 'checkbox',
      checkedState: '',
      options: [
        { name: 'Select All', value: 'all' },
        { name: 'Image', value: 'image' },
        { name: 'Video', value: 'video' },
        { name: 'Promo/Trailer', value: 'trailer' },
        { name: 'Audio', value: 'audio' },
        { name: 'Subtitle', value: 'SRT' },
        // { name: 'Recorded LIVE', value: 'live' },
      ],
      onSelect: (checked, value) => {
        onTypeFilterChange(checked, value)
      },
    },
    {
      title: 'Mapped to Content',
      type: 'radio',
      checkedState: '',
      options: [
        { name: 'Yes', value: 'true' },
        { name: 'No', value: 'false' },
      ],
      onSelect: (value) => {
        onMapFilterChange(value)
      },
    },
    {
      title: 'Sort by',
      type: 'radio',
      checkedState: '',
      options: [
        { name: 'Upload date', value: 'created_at' },
        { name: 'Name', value: 'file_name' },
        { name: 'Size: Low to High', value: 'file_metadata.file_size' },
      ],
      onSelect: (value) => {
        onOrderByChange(value)
      },
    },
  ]
  const allTypeArr = ['all', 'image', 'video', 'trailer', 'audio', 'SRT']
  const [filters, setFilters] = useState(filterIntialValue)

  const [{ data: assetList, loading: assetListLoading }, assetListCall] = useAxios(
    {
      url: `${ASSET_API}?customer_id=${accountId}&page_size=${PAGE_SIZE}`,
      method: 'get',
    },
    { manual: true },
  )

  useEffect(() => {
    assetListCall({
      params: {
        asset_type: type.toLowerCase(),
      },
    })
    let tempArr = [`${type.toLowerCase()}`]

    setTypeFilter([...tempArr])
    handleFilterChange(2, tempArr)
  }, [type])

  useEffect(() => {
    setLoader(assetListLoading)
  }, [assetListLoading])

  useEffect(() => {
    if (assetList && assetList.success) {
      let data = assetList.data

      page === 1 ? setAssetData(data) : setAssetData((assetData) => [...assetData, ...data])
    }
  }, [assetList])

  const onDateFilterChange = (date) => {
    setDateCheckedValue(date)
    const start = moment().startOf(`${date}`).unix()
    const end = moment().unix()

    setDateFilter(date ? `${start}, ${end}` : '')
    handleFilterChange(0, date)
  }

  const onSizeFilterChange = (value) => {
    setSizeFilter(value)
    handleFilterChange(1, value)
  }

  const onMapFilterChange = (value) => {
    setMappedFilter(value ? value : null)
    handleFilterChange(3, value)
  }

  const onOrderByChange = (value) => {
    if (value === 'created_at') {
      setReverse(true)
    } else setReverse(false)

    setOrderByFilter(value)

    handleFilterChange(4, value)
  }

  const onTypeFilterChange = (checked, value) => {
    if (checked) {
      if (value === 'all') {
        handleFilterChange(2, allTypeArr)
        setTypeFilter(allTypeArr)
        return
      }
      setTypeFilter((prev) => {
        handleFilterChange(2, [...prev, value])
        return [...prev, value]
      })
    } else {
      if (value === 'all') {
        handleFilterChange(2, [])
        setTypeFilter([])
        return
      }

      setTypeFilter((prev) => {
        handleFilterChange(
          2,
          [...prev].filter((type) => type !== value),
        )
        return [...prev].filter((type) => type !== value)
      })
    }
  }

  const handleFilterChange = (index, value) => {
    setFilters((prev) => {
      prev[index] = { ...prev[index], checkedState: value }
      return [...prev]
    })
  }

  const applyFilter = () => {
    setSelectedAsset({})
    setPage(1)
    assetListCall({
      params: {
        page: 1,
        search_text: searchText,
        uploaded_in_between: dateFilter,
        size_in_between: sizeFilter,
        mapped_to_content: mappedFilter,
        asset_type: typeFilter.filter((type) => type !== 'all').toString(),
        order_by: orderByFilter,
        reverse: reverse,
      },
    })
  }

  const handleAssetSelect = (asset) => {
    console.log(asset)
    // console.log(type)
    setSelectedAsset(asset)
  }

  const validateAsset = () => {
    let isFormValid = true

    if (isEmpty(selectedAsset)) {
      isFormValid = false
    }
    if (!isEmpty(selectedAsset)) {
      if (type.toLowerCase() === 'trailer' && !selectedAsset?.is_trailer) {
        isFormValid = false
        raiseToast('error', `Select a ${type.toLowerCase()} File.`)
      }

      if (type.toLowerCase() === 'video' && selectedAsset?.is_trailer) {
        isFormValid = false
        raiseToast(
          'error',
          `Oops! you have selected a trailer video. Please select a Valid Content Video file.`,
        )
      }

      if (
        type.toLowerCase() !== 'trailer' &&
        !selectedAsset?.file_metadata?.file_type.includes(type.toLowerCase())
      ) {
        isFormValid = false
        raiseToast('error', `Select a ${type.toLowerCase()} File.`)
      }
    }

    return isFormValid
  }

  const handleSelect = () => {
    if (validateAsset()) {
      setAsset(selectedAsset)
    }
  }

  const resetFilters = () => {
    setSelectedAsset({})
    setFilters(filterIntialValue)
    setSizeFilter('')
    setMappedFilter(null)
    setDateFilter('')
    setDateCheckedValue('')
    setOrderByFilter('created_at')
    setTypeFilter([])
    setPage(1)
    assetListCall({
      params: {
        page_no: 1,
        search_text: searchText,
        asset_type: '',
      },
    })
  }

  const handleSearch = (value) => {
    setSearchText(value)

    setPage(1)
    assetListCall({
      params: {
        page_no: 1,
        search_text: `${value}`,
        uploaded_in_between: dateFilter,
        size_in_between: sizeFilter,
        mapped_to_content: mappedFilter,
        asset_type: typeFilter.filter((type) => type !== 'all').toString(),
        order_by: orderByFilter,
        reverse: reverse,
      },
    })
  }

  const handleNextPage = () => {
    assetListCall({
      params: {
        page_no: page + 1,
        search_text: searchText,
        uploaded_in_between: dateFilter,
        size_in_between: sizeFilter,
        mapped_to_content: mappedFilter,
        asset_type: typeFilter.filter((type) => type !== 'all').toString(),
        order_by: orderByFilter,
        reverse: reverse,
      },
    })
    setPage((page) => page + 1)
  }

  useEffect(() => {
    setBasicInfo([
      {
        property: 'File Name',
        value: selectedAsset?.file_name,
      },
      {
        property: 'File Type',
        value: capitalize(selectedAsset?.file_metadata?.file_type?.split('/')[0]),
      },
      { property: 'Trailer/Promo', value: selectedAsset?.is_trailer === true ? 'Yes' : 'No' },
      {
        property: 'Mapped to Content',
        value: selectedAsset?.is_mapped_to_content === true ? 'Yes' : 'No',
      },
      { property: 'Format', value: selectedAsset?.file_metadata?.file_type?.split('/')[1] },
      { property: 'Size', value: formatBytes(selectedAsset?.file_metadata?.file_size) },
      {
        property: 'Duration',
        value: convertDuration(selectedAsset?.file_metadata?.duration).replace(':', ' '),
      },
      {
        property: 'Uploaded On',
        value: moment.unix(selectedAsset?.created_at).format('DD MMM YYYY'),
      },
      { property: 'Uploaded By', value: 'N/A' },
      {
        property: 'Updated On',
        value: moment.unix(selectedAsset?.updated_at).format('DD MMM YYYY'),
      },
      { property: 'Last Edited By', value: 'N/A' },
      { property: 'Permalink', value: 'N/A' },
    ])
  }, [selectedAsset])

  const [basicInfo, setBasicInfo] = useState([])

  return (
    <CModal scrollable size="xl" visible={true} className="asset-manager-modal">
      <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
      <div>
        {previewSlider && (
          <PreviewDetails
            onClose={() => setPreviewSlider(false)}
            cardImage={
              selectedAsset?.file_metadata?.file_type.includes('video')
                ? getVideoThumbnail(
                    userSessionObj.session_data.cf_domain_name,
                    selectedAsset.asset_id,
                  )
                : getThumbnail(userSessionObj.session_data.cf_domain_name, selectedAsset.s3_key)
            }
            headline="Asset Preview"
            subHeadline="Detailed information about the selected Asset"
            basicInfo={basicInfo}
            resolutions={selectedAsset?.progress}
          />
        )}
        <div
          style={{
            padding: '1.42vw 0 0 1.63vw',
          }}
        >
          <h5
            style={{
              color: '#191818',
              fontSize: '30px',
              fontWeight: '700',
            }}
          >
            Select from Asset Manager
          </h5>
          <span>Choose file from Asset Manager</span>
        </div>

        <div
          className="d-flex justify-content-center"
          style={{
            padding: '1.42vw 1vw 0',
            margin: '0 auto 1.5vh',
            width: '97.5%',
            // outline: '2px solid red',
            position: 'relative',
          }}
        >
          <h6 style={{ marginRight: 'auto' }}>
            Assets ({assetList?.total ? assetList?.total : 0} items)
          </h6>
          <AssetFilter
            filters={filters}
            onSearch={handleSearch}
            onApply={applyFilter}
            onClearAll={resetFilters}
            dropdownHeight={'300px'}
          />
          <div
            className="d-flex justify-content-start align-items-center rounded-1 overflow-hidden"
            style={{ border: '0.5px solid #707070' }}
          >
            <div
              className="d-flex justify-content-center align-items-center"
              style={{
                height: '100%',
                backgroundColor: !listView ? '#000' : '#fff',
                padding: 'max(.42vw,8px) .84vw',
                cursor: 'pointer',
              }}
              onClick={() => setListView(false)}
            >
              <img
                src={GridViewIcon}
                alt=""
                className="h-100"
                style={{ filter: !listView ? 'invert(0)' : 'invert(1)' }}
              />
            </div>
            <div
              className="d-flex justify-content-center align-items-center"
              style={{
                height: '100%',
                backgroundColor: listView ? '#000' : '#fff',
                padding: 'max(.42vw,8px) .84vw',
                cursor: 'pointer',
              }}
              onClick={() => setListView(true)}
            >
              <img
                src={ListViewIcon}
                alt=""
                className="h-100"
                style={{ filter: !listView ? 'invert(0)' : 'invert(1)' }}
              />
            </div>
          </div>
        </div>
        <CModalBody>
          <div
            id="scrollableDiv"
            className="asset-manager-card position-relative"
            style={{ borderTop: listView ? 'none' : '.5px solid #707070' }}
          >
            <InfiniteScroll
              dataLength={assetData.length} //This is important field to render the next data
              next={handleNextPage}
              hasMore={assetList && assetList.total > page * PAGE_SIZE}
              style={{ overflowX: 'hidden' }}
              loader={<p>Loading...</p>}
              className="scrollbar-class"
              height={`48.5vh`}
              scrollableTarget="scrollableDiv"
            >
              {listView && (
                <div
                  className="d-flex justify-content-center align-items-center bg-black text-white position-absolute rounded-1"
                  style={{
                    fontSize: 'max(0.63vw,10px)',
                    gap: '0 2.2%',
                    padding: '2px .6vw',
                    top: '0',
                    right: '0',
                    zIndex: '1',
                    width: '99.2%',
                  }}
                >
                  <div style={{ width: '9%', height: '100%' }}></div>
                  <div
                    className="d-flex justify-content-between align-items-center"
                    style={{ width: '85%' }}
                  >
                    <p style={{ marginBlockEnd: '0', width: '20%' }}>Title</p>
                    <p style={{ marginBlockEnd: '0', width: '12%' }}>Duration</p>
                    <p style={{ marginBlockEnd: '0', width: '12%' }}>Upload Date</p>
                    <p style={{ marginBlockEnd: '0', width: '12%' }}>File Format</p>
                    <p style={{ marginBlockEnd: '0', width: '21%' }}>Mapped To Content</p>
                    <div style={{ width: '2%' }}></div>
                  </div>
                </div>
              )}
              <div
                className="d-flex flex-wrap"
                style={{
                  gap: '1.2vw 1.6%',
                  padding: listView ? '30px 8px 20px 8px' : '20px 8px 20px 8px',
                }}
              >
                {!isEmpty(assetData) ? (
                  assetData.map((info, index) =>
                    listView ? (
                      <CustomListCard
                        cardImage={
                          info?.file_metadata?.file_type.includes('video')
                            ? getVideoThumbnail(
                                userSessionObj.session_data.cf_domain_name,
                                info.asset_id,
                              )
                            : getThumbnail(userSessionObj.session_data.cf_domain_name, info.s3_key)
                        }
                        fileName={info?.file_name}
                        releasedDate={moment(info?.created_date).format('DD MMM YYYY')}
                        duration={
                          info?.source_asset || info?.live_expiry_time
                            ? info?.source_asset?.file_metadata?.duration
                              ? convertDuration(info?.source_asset?.file_metadata?.duration)
                              : moment(info?.live_expiry_time).diff(
                                  moment(info?.publish_time),
                                  'hours',
                                ) +
                                'h ' +
                                (moment(info?.live_expiry_time).diff(
                                  moment(info?.publish_time),
                                  'minutes',
                                ) %
                                  60) +
                                'm'
                            : 'N/A'
                        }
                        key={index}
                        contentType={`.${info?.file_metadata?.file_type?.split('/')[1]}`} // using as File Format
                        // category={info?.is_mapped_to_content === true ? 'Yes' : 'No'}
                        categories={[info?.is_mapped_to_content === true ? 'Yes' : 'No']} // using as Mapped to Content
                        isCategory={false}
                        actionButton={'PREVIEW'}
                        actionButtonAction={() => setPreviewSlider(true)}
                        isSelectable={
                          info?.file_metadata?.file_type.includes('video')
                            ? info?.progress[480] === 100
                            : true
                        }
                        isSelected={info.asset_id === selectedAsset.asset_id}
                        onSelect={() => handleAssetSelect(info)}
                      />
                    ) : (
                      <CustomCard
                        cardImage={
                          info?.file_metadata?.file_type.includes('video')
                            ? getVideoThumbnail(
                                userSessionObj.session_data.cf_domain_name,
                                info.asset_id,
                              )
                            : getThumbnail(userSessionObj.session_data.cf_domain_name, info.s3_key)
                        }
                        playIconForVideo={info?.file_metadata?.file_type.includes('video')}
                        fileName={info?.file_name}
                        leftText={formatBytes(info?.file_metadata?.file_size)}
                        rightText={moment.unix(info?.created_at).format('DD MMM YYYY')}
                        key={index}
                        isSelectable={
                          info?.file_metadata?.file_type.includes('video')
                            ? info?.progress[480] === 100
                            : true
                        }
                        isSelected={info.asset_id === selectedAsset.asset_id}
                        onSelect={() => handleAssetSelect(info)}
                        actionButton={'PREVIEW'}
                        actionButtonAction={() => setPreviewSlider(true)}
                      />
                    ),
                  )
                ) : (
                  <h5 className="no-data-text">No Asset Found!</h5>
                )}
              </div>
            </InfiniteScroll>
          </div>
        </CModalBody>
        <CModalFooter style={{ border: 'none', padding: '0 1.63vw 1.42vw 0' }}>
          <CButton
            className=""
            style={{
              color: '#3a3838',
              backgroundColor: 'white',
              marginRight: '2rem',
              border: '1px solid #bdbdbd',
              borderRadius: '5px',
            }}
            onClick={onCancel}
          >
            Cancel
          </CButton>
          <CButton
            color="info"
            className="text-white"
            style={{
              color: 'white',
              backgroundColor: '#20211c',
              border: '1px solid #bdbdbd',
              borderRadius: '5px',
            }}
            onClick={handleSelect}
          >
            Select
          </CButton>
        </CModalFooter>
      </div>
    </CModal>
  )
}

export default AssetManagerNew
